import { createFileRoute } from "@tanstack/react-router";
import { CookiesList } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/cookie-management/")({
  component: () => <CookiesList />,
});

export { Route };
